import React, { lazy } from "react";

import async from "./components/Async";
//TODO >> deep understand the following lines and decide is it better to load all pages asynchronously or not
// All pages that rely on 3rd party components (other than Material-UI) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
import AuthLayout from "./layouts/Auth";
import DashboardLayout from "./layouts/Dashboard";
import DocLayout from "./layouts/Doc";
import PresentationLayout from "./layouts/Presentation";

// Guards
//ABUBAKR Note :> no need for AuthGuard here because I've wraped all routes within it in App.js
//import AuthGuard from "./components/guards/AuthGuard";

// Auth components
import SignIn from "./pages/auth/SignIn";
import SignUp from "./pages/auth/SignUp";
import ResetPassword from "./pages/auth/ResetPassword";
import Page404 from "./pages/auth/Page404";
import Page500 from "./pages/auth/Page500";

// Components
import Accordion from "./pages/components/Accordion";
import Alerts from "./pages/components/Alerts";
import Avatars from "./pages/components/Avatars";
import Badges from "./pages/components/Badges";
import Buttons from "./pages/components/Buttons";
import Cards from "./pages/components/Cards";
import Chips from "./pages/components/Chips";
import Dialogs from "./pages/components/Dialogs";
import Lists from "./pages/components/Lists";
import Menus from "./pages/components/Menus";
import Pagination from "./pages/components/Pagination";
import Progress from "./pages/components/Progress";
import Snackbars from "./pages/components/Snackbars";
import Tooltips from "./pages/components/Tooltips";

// Form components
import SelectionCtrls from "./pages/forms/SelectionControls";
import Selects from "./pages/forms/Selects";
import TextFields from "./pages/forms/TextFields";

// Icon components
import MaterialIcons from "./pages/icons/MaterialIcons";

// Page components
import TestPage from "./pages/pages/testPage/TestPage";
import GATrxPage from "./pages/pages/gaTrx/GATrxPage";
import InvTrxPage from "./pages/pages/invTrx/InvTrxPage";
import AWBTrxPage from "./pages/pages/awbTrx/AWBTrxPage";
import Blank from "./pages/pages/Blank";
import InvoiceDetails from "./pages/pages/InvoiceDetails";
import InvoiceList from "./pages/pages/InvoiceList";
import Orders from "./pages/pages/Orders";
import Pricing from "./pages/pages/Pricing";
import Settings from "./pages/pages/Settings";
import Projects from "./pages/pages/Projects";
import Chat from "./pages/pages/Chat";

// Table components
import SimpleTable from "./pages/tables/SimpleTable";
import AdvancedTable from "./pages/tables/AdvancedTable";

// Documentation
import Welcome from "./pages/docs/Welcome";
import GettingStarted from "./pages/docs/GettingStarted";
import Routing from "./pages/docs/Routing";
import Auth0 from "./pages/docs/auth/Auth0";
import Cognito from "./pages/docs/auth/Cognito";
import Firebase from "./pages/docs/auth/Firebase";
import JWT from "./pages/docs/auth/JWT";
import Guards from "./pages/docs/Guards";
import EnvironmentVariables from "./pages/docs/EnvironmentVariables";
import Deployment from "./pages/docs/Deployment";
import Theming from "./pages/docs/Theming";
import APICalls from "./pages/docs/APICalls";
import Redux from "./pages/docs/Redux";
import Internationalization from "./pages/docs/Internationalization";
import ESLintAndPrettier from "./pages/docs/ESLintAndPrettier";
import Support from "./pages/docs/Support";
import Changelog from "./pages/docs/Changelog";

// Landing
import Landing from "./pages/presentation/Landing";

// Protected routes
import ProtectedPage from "./pages/protected/ProtectedPage";

//settings
import Country from "./pages/pages/settings/lookups/Country";
import Destination from "./pages/pages/settings/lookups/Destination";
//GL
import FiscalYears from "./pages/pages/gl/lookups/FiscalYears";
import SubLedgers from "./pages/pages/gl/lookups/SubLedgers";
import Ledgers from "./pages/pages/gl/lookups/Ledgers";
import SubLedgersRpt from "./pages/pages/gl/reports/SubLedgersRpt";
import FiscalYearsPeriods from "./pages/pages/gl/lookups/FiscalYearsPeriods";
import ReportViewer from "./pages/ReportViewer/index";
import RateClass from "./pages/pages/settings/lookups/RateClass";
import SalesAgent from "./pages/pages/settings/lookups/SalesAgent";
import SalesPerson from "./pages/pages/settings/lookups/SalesPerson";
import LookupPage from "./pages/pages/settings/lookups/LookupPage";
import Item from "./pages/pages/settings/lookups/Item";

// Dashboard components
const Default = async(() => import("./pages/dashboards/Default"));
const Analytics = async(() => import("./pages/dashboards/Analytics"));
const SaaS = async(() => import("./pages/dashboards/SaaS"));

// Form components
const Pickers = async(() => import("./pages/forms/Pickers"));
const Editors = async(() => import("./pages/forms/Editors"));
const Formik = async(() => import("./pages/forms/Formik"));

// Icon components
const FeatherIcons = async(() => import("./pages/icons/FeatherIcons"));
const Profile = async(() => import("./pages/pages/Profile"));
const Tasks = async(() => import("./pages/pages/Tasks"));
const Calendar = async(() => import("./pages/pages/Calendar"));

// Table components
const DataGrid = async(() => import("./pages/tables/DataGrid"));

// Chart components
const Chartjs = async(() => import("./pages/charts/Chartjs"));
const ApexCharts = async(() => import("./pages/charts/ApexCharts"));

// Maps components
const GoogleMaps = async(() => import("./pages/maps/GoogleMaps"));
const VectorMaps = async(() => import("./pages/maps/VectorMaps"));

const getTrxComponent = (componentName) => {
  switch (componentName) {
    case "GATrxPage":
      return GATrxPage;
    case "AWBTrxPage":
      return AWBTrxPage;
    case "InvTrxPage":
      return InvTrxPage;
    case "SubLedgers":
      return SubLedgers;
    case "LookupPage":
      return LookupPage;
    default:
      return null;
  }
};

const buildTrxRoutes = (routeDefs = []) =>
  routeDefs.flatMap(({ routeCode, componentName }) => {
    const Component = getTrxComponent(componentName);

    if (!Component) {
      return [];
    }

    return [
      {
        path: `${routeCode}/:id`,
        element: <Component key={routeCode} menuItemCode={routeCode} />,
      },
      {
        path: routeCode,
        element: <Component key={routeCode} menuItemCode={routeCode} />,
      },
    ];
  });

const createRoutes = ({ dynamicRoutes } = {}) => [
  //ABUBAKR TEMP
  // {
  //   path: "/",
  //   element: <DashboardLayout />,
  //   children: [
  //     {
  //       path: "",
  //       element: <TestPage />,
  //     },
  //   ],
  // },
  // {
  //   path: "/",
  //   element: <PresentationLayout />,
  //   children: [
  //     {
  //       path: "",
  //       element: <Landing />,
  //     },
  //   ],
  // },
  {
    path: "/",
    element: <DashboardLayout />,
  },
  {
    path: "dashboard",
    element: <DashboardLayout />,
    children: [
      {
        path: "default",
        element: <Default />,
      },
      {
        path: "analytics",
        element: <Analytics />,
      },
      {
        path: "saas",
        element: <SaaS />,
      },
    ],
  },

  {
    path: "pages",
    element: <DashboardLayout />,
    children: [
      {
        path: "reports/:id",
        element: <ReportViewer />,
        // element: lazy(() => import("src/pages/ReportViewer/index")),
      },
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "settings",
        element: <Settings />,
      },
      {
        path: "pricing",
        element: <Pricing />,
      },
      {
        path: "chat",
        element: <Chat />,
      },

      //Abubakr Note : react-router-dom V6 don't support optional parameter
      //so we have to add 2 or more routes based on number of optional parameter
      {
        path: "testPage/:id",
        element: (
          <TestPage
            key="testPage"
            menuItemCode="testPage" /*I've added MenuItemCode to use it in getting form controls because in VS I can't get route path as I want */
          />
        ),
      },
      {
        path: "testPage",
        element: <TestPage key="testPage" menuItemCode="testPage" />,
      },
      ...buildTrxRoutes(dynamicRoutes),
      //End Note
      {
        path: "blank",
        element: <Blank />,
      },
      {
        path: "fiscalyears/:id",
        element: (
          <FiscalYears
            key="fiscalyears"
            menuItemCode="fiscalyears" /*I've added MenuItemCode to use it in getting form controls because in VS I can't get route path as I want */
          />
        ),
      },
      {
        path: "fiscalyears",
        element: <FiscalYears key="fiscalyears" menuItemCode="fiscalyears" />,
      },
      /*SETTINGS */
      {
        path: "country/:id",
        element: (
          <Country
            key="country"
            menuItemCode="country" /*I've added MenuItemCode to use it in getting form controls because in VS I can't get route path as I want */
          />
        ),
      },
      {
        path: "country",
        element: <Country key="country" menuItemCode="country" />,
      },
      {
        path: "destination/:id",
        element: <Destination key="destination" menuItemCode="destination" />,
      },
      {
        path: "destination",
        element: <Destination key="destination" menuItemCode="destination" />,
      },
      {
        path: "rateClass/:id",
        element: <RateClass key="destination" menuItemCode="rateClass" />,
      },
      {
        path: "rateClass",
        element: <RateClass key="rateClass" menuItemCode="rateClass" />,
      },
      {
        path: "salesAgent/:id",
        element: <SalesAgent key="salesAgent" menuItemCode="salesAgent" />,
      },
      {
        path: "salesAgent",
        element: <SalesAgent key="salesAgent" menuItemCode="salesAgent" />,
      },
      {
        path: "salesPerson/:id",
        element: <SalesPerson key="salesPerson" menuItemCode="salesPerson" />,
      },
      {
        path: "salesPerson",
        element: <SalesPerson key="salesPerson" menuItemCode="salesPerson" />,
      },
      {
        path: "item/:id",
        element: <Item key="item" menuItemCode="item" />,
      },
      {
        path: "item",
        element: <Item key="item" menuItemCode="item" />,
      },
      {
        path: "ledgers/:id",
        element: (
          <Ledgers
            key="ledgers"
            menuItemCode="ledgers" /*I've added MenuItemCode to use it in getting form controls because in VS I can't get route path as I want */
          />
        ),
      },
      {
        path: "ledgers",
        element: <Ledgers key="ledgers" menuItemCode="ledgers" />,
      },

      {
        path: "subledgersrpt/:id",
        element: (
          <SubLedgersRpt
            key="subledgersRpt" /*I've added MenuItemCode to use it in getting form controls because in VS I can't get route path as I want */
            menuItemCode="subledgersRpt" /*I've added MenuItemCode to use it in getting form controls because in VS I can't get route path as I want */
          />
        ),
      },
      {
        path: "subledgersrpt",
        element: (
          <SubLedgersRpt key="subledgersRpt" menuItemCode="subledgersRpt" />
        ),
      },
      {
        path: "fiscalYearsPeriods/:id",
        element: (
          <FiscalYearsPeriods
            key="fiscalYearsPeriods" /*I've added MenuItemCode to use it in getting form controls because in VS I can't get route path as I want */
            menuItemCode="fiscalYearsPeriods" /*I've added MenuItemCode to use it in getting form controls because in VS I can't get route path as I want */
          />
        ),
      },
      {
        path: "fiscalYearsPeriods",
        element: (
          <FiscalYearsPeriods
            key="FiscalYearsPeriods"
            menuItemCode="FiscalYearsPeriods"
          />
        ),
      },
    ],
  },

  {
    path: "projects",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <Projects />,
      },
    ],
  },
  {
    path: "invoices",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <InvoiceList />,
      },
      {
        path: "detail",
        element: <InvoiceDetails />,
      },
    ],
  },
  {
    path: "orders",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <Orders />,
      },
    ],
  },
  {
    path: "tasks",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <Tasks />,
      },
    ],
  },
  {
    path: "calendar",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <Calendar />,
      },
    ],
  },
  {
    path: "auth",
    element: <AuthLayout />,
    children: [
      {
        path: "sign-in",
        element: <SignIn />,
      },
      {
        path: "sign-up",
        element: <SignUp />,
      },
      {
        path: "reset-password",
        element: <ResetPassword />,
      },
      {
        path: "404",
        element: <Page404 />,
      },
      {
        path: "500",
        element: <Page500 />,
      },
    ],
  },
  {
    path: "components",
    element: <DashboardLayout />,
    children: [
      {
        path: "accordion",
        element: <Accordion />,
      },
      {
        path: "alerts",
        element: <Alerts />,
      },
      {
        path: "avatars",
        element: <Avatars />,
      },
      {
        path: "badges",
        element: <Badges />,
      },
      {
        path: "buttons",
        element: <Buttons />,
      },
      {
        path: "cards",
        element: <Cards />,
      },
      {
        path: "chips",
        element: <Chips />,
      },
      {
        path: "dialogs",
        element: <Dialogs />,
      },
      {
        path: "lists",
        element: <Lists />,
      },
      {
        path: "menus",
        element: <Menus />,
      },
      {
        path: "pagination",
        element: <Pagination />,
      },
      {
        path: "progress",
        element: <Progress />,
      },
      {
        path: "snackbars",
        element: <Snackbars />,
      },
      {
        path: "tooltips",
        element: <Tooltips />,
      },
    ],
  },
  {
    path: "forms",
    element: <DashboardLayout />,
    children: [
      {
        path: "pickers",
        element: <Pickers />,
      },
      {
        path: "selection-controls",
        element: <SelectionCtrls />,
      },
      {
        path: "selects",
        element: <Selects />,
      },
      {
        path: "text-fields",
        element: <TextFields />,
      },
      {
        path: "editors",
        element: <Editors />,
      },
      {
        path: "formik",
        element: <Formik />,
      },
    ],
  },
  {
    path: "tables",
    element: <DashboardLayout />,
    children: [
      {
        path: "simple-table",
        element: <SimpleTable />,
      },
      {
        path: "advanced-table",
        element: <AdvancedTable />,
      },
      {
        path: "data-grid",
        element: <DataGrid />,
      },
    ],
  },
  {
    path: "icons",
    element: <DashboardLayout />,
    children: [
      {
        path: "material-icons",
        element: <MaterialIcons />,
      },
      {
        path: "feather-icons",
        element: <FeatherIcons />,
      },
    ],
  },
  {
    path: "charts",
    element: <DashboardLayout />,
    children: [
      {
        path: "chartjs",
        element: <Chartjs />,
      },
      {
        path: "apexcharts",
        element: <ApexCharts />,
      },
    ],
  },
  {
    path: "maps",
    element: <DashboardLayout />,
    children: [
      {
        path: "google-maps",
        element: <GoogleMaps />,
      },
      {
        path: "vector-maps",
        element: <VectorMaps />,
      },
    ],
  },
  {
    path: "documentation",
    element: <DocLayout />,
    children: [
      {
        path: "welcome",
        element: <Welcome />,
      },
      {
        path: "getting-started",
        element: <GettingStarted />,
      },
      {
        path: "routing",
        element: <Routing />,
      },
      {
        path: "auth/auth0",
        element: <Auth0 />,
      },
      {
        path: "auth/cognito",
        element: <Cognito />,
      },
      {
        path: "auth/firebase",
        element: <Firebase />,
      },
      {
        path: "auth/jwt",
        element: <JWT />,
      },
      {
        path: "guards",
        element: <Guards />,
      },
      {
        path: "environment-variables",
        element: <EnvironmentVariables />,
      },
      {
        path: "deployment",
        element: <Deployment />,
      },
      {
        path: "theming",
        element: <Theming />,
      },
      {
        path: "api-calls",
        element: <APICalls />,
      },
      {
        path: "redux",
        element: <Redux />,
      },
      {
        path: "internationalization",
        element: <Internationalization />,
      },
      {
        path: "eslint-and-prettier",
        element: <ESLintAndPrettier />,
      },
      {
        path: "support",
        element: <Support />,
      },
    ],
  },
  {
    path: "changelog",
    element: <DocLayout />,
    children: [
      {
        path: "",
        element: <Changelog />,
      },
    ],
  },
  {
    path: "private",
    element: (
      //ABUBAKR Note :> no need for AuthGuard here because I've wraped all routes within it in App.js
      //It'll be helpfull with Madd
      // <AuthGuard>
      <DashboardLayout />
      // </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <ProtectedPage />,
      },
    ],
  },
  {
    path: "*",
    element: <AuthLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default createRoutes;
